<template>
    <div class="fill-height of-y">
        <v-row
                no-gutters
                class="of-y fill-height"
        >
            <v-col class="fill-height of-y" cols="3">
                <multi-select-list
                        solo
                        :items="farmFilteredEmp"
                        itemKey="id"
                        :showCheckBoxes="true"
                        :multiple="true"
                        headlineKey="fullName"
                        sub-line-key="idNo"
                        v-model="selectedEmpID"
                        :return-object="false"
                        filterLabel="Filter Employees"
                        :custom-filter="empFilter"
                        @input="con.log($event)"
                >
                    <div slot="header" class="px-2 pt-2">
                        <v-btn
                                small
                                block
                                color="primary"
                                @click="importEmpShow = !importEmpShow"
                                class="mb-2"
                        >
                            <v-icon left>mdi-application-import</v-icon>
                            Import Employees
                        </v-btn>
                        <v-btn
                                small
                                block
                                color="primary"
                                class="my-2"
                                @click="batchDisableShow = !batchDisableShow"
                        >
                            <v-icon left>mdi-account-remove</v-icon>
                            Batch Disable
                        </v-btn>
                        <v-btn
                                small
                                block
                                color="primary"
                                @click="createEmpShow = !createEmpShow"
                        >
                            <v-icon left>mdi-account-tie</v-icon>
                            Add Employee
                        </v-btn>

                        <v-btn
                            small
                            block
                            color="primary"
                            class="my-2"
                            @click="createWarningShow = !createWarningShow"
                        >
                            <v-icon left>mdi-alert</v-icon>
                            Issue Warning Warrants
                        </v-btn>
                        <div class="py-2 d-flex align-center">
                            <v-autocomplete
                                    dense
                                    placeholder="Filter By Farm"
                                    hide-details
                                    prepend-inner-icon="mdi-tractor"
                                    no-data-text="No available farms"
                                    v-model="farmFilter"
                                    item-text="description"
                                    item-value="id"
                                    :items="sortedFarms"
                                    :multiple="false"
                                    :clearable="true"
                                    class="flex-grow-1"
                            />
                            <v-tooltip left>
                                <template v-slot:activator="{on}">
                                    <v-btn
                                            @click="showDisabled = !showDisabled"
                                            icon
                                            text
                                            class="pa-0 ma-0 ml-1"
                                            v-on="on"
                                            color="primary"
                                    >
                                        <v-icon>{{showDisabled ? 'mdi-account-off' : 'mdi-account'}}</v-icon>
                                    </v-btn>
                                </template>

                                {{showDisabled ? 'Hide Disabled' : 'Show Disabled'}}
                            </v-tooltip>
                        </div>
                    </div>
                    <template v-slot:headline="{value, index, selected}">
                        <div class="d-flex align-center justify-space-between" :class="value.disabled ? 'grey--text' : null">
                            <div>
                                {{value.fullName || 'No Name Set'}}
                            </div>
                            <div>
                                {{ value.farm.description }}
                            </div>
                        </div>
                    </template>
                    <template v-slot:subLine="{value, index, selected}">
                        <div class="d-flex align-center justify-space-between grey--text" :class="value.disabled ? null : 'text--darken-2'">
                            <div>
                                {{value.disabled ? 'DISABLED' : value.empCode}}
                            </div>
                            <div>
                                {{ value.idNo }}
                            </div>
                        </div>
                    </template>
                </multi-select-list>
            </v-col>
            <divider color="primary darken-1" :vertical="true"/>
            <v-col class="fill-height of-y pa-2" v-if="selectedEmpID.length">
                <v-card max-width="600">
                    <ModifyEmp v-if="selectedEmp" :edit-emp="selectedEmp" @save="upsertEmp($event)"/>
                    <emp-mult-edit v-if="selectedEmpID.length > 1" :selected-employees="selectedEmpID"></emp-mult-edit>
                </v-card>
                <v-card class="mt-2" v-if="selectedEmp" max-width="600">
                    <div class="primary d-flex align-center">
                        <div class="flex-grow-1 primary pl-3 pr-2 sub--text">
                            {{selectedEmp.fullName || 'Employee'}} Barcodes
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <manage-barcodes ref-key="fkEmp" :ref-val="selectedEmp.id"/>
                </v-card>
                <v-card class="mt-2" v-if="selectedEmp" max-width="600">
                    <div class="primary d-flex align-center">
                        <div class="flex-grow-1 primary pl-3 pr-2 sub--text">
                            Status History
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <emp-status-history ref="statusHistory" :fk-emp="selectedEmp.id"/>
                </v-card>
                <v-card class="mt-2" v-if="selectedEmp" max-width="600">
                    <div class="primary d-flex align-center">
                        <div class="flex-grow-1 primary pl-3 pr-2 sub--text">
                            Warning History
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <emp-warning-history ref="statusHistory" :fk-emp="selectedEmp.id"/>
                </v-card>
            </v-col>
            <v-dialog
                    v-if="createEmpShow"
                    v-model="createEmpShow"
                    :width="400"
                    persistent
            >
                <v-card>
                    <ModifyEmp :edit-emp="createEmpObj" @dismiss="createEmpShow = !createEmpShow" @save="upsertEmp($event)"/>
                </v-card>
            </v-dialog>
        </v-row>
        <ImportEmp
                v-if="importEmpShow"
                v-model="importEmpShow"
        />
        <BatchDisableEmp
                v-if="batchDisableShow"
                v-model="batchDisableShow"
        />
        <create-warings
            v-if="createWarningShow"
            v-model="createWarningShow"
        />
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyEmp from "./ModifyEmp";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";
import ManageBarcodes from "../Manage Barcodes/ManageBarcodes";
import ImportEmp from "./Import/ImportEmp";
import BatchDisableEmp from "./BatchDisable/BatchDisableEmp";
import EmpMultEdit from "./EmpMultEdit";
import CreateWarings from "@/components/Setup/Emp/Warnings/CreateWarings.vue";
import EmpStatusHistory from "@/components/Setup/Emp/EmpStatusHistory.vue";
import EmpWarningHistory from "@/components/Setup/Emp/EmpWarningHistory.vue";

export default {
    components: {
        EmpWarningHistory,
        EmpStatusHistory,
        CreateWarings,
        EmpMultEdit,
        BatchDisableEmp,
        ImportEmp,
        ManageBarcodes,
        Divider,
        ModifyEmp,
        MultiSelectList
    },
    props: {},
    data() {
        return {
            con: console,
            selectedEmpID: [],
            createEmpObj: null,
            createEmpShow: false,
            importEmpShow: false,
            batchDisableShow: false,
            farmFilter: null,
            empFilter: function (searchStr, obj) {
                if (!searchStr)
                    return true
                if (!isNaN(searchStr) && searchStr.length === 4)
                    return obj.empCode === searchStr
                return JSON.stringify(obj).toLowerCase().includes((searchStr.toLowerCase()))
            },
            createWarningShow: false
        }
    },
    watch: {
        createEmpShow(val) {
            if (val)
                this.createEmpObj = {
                    id: null,
                    fullName: null,
                    idNo: null,
                    empCode: null,
                    fkFarm: null
                }
        }
    },
    methods: {

        async upsertEmp(event) {
            console.log(event)
            let {emp, ref} = event;
            ref.loading = true;
            try {
                const eventID = await this.$newReq('POST', `setup/emp`, emp)
                const addedEmpID = (await waitForEvent(eventID)).emp.pop().id
                this.createEmpShow = false
                this.selectedEmpID = [addedEmpID];
                this.$snack.info('Changes saved')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                ref.loading = false;
                if (this.$refs.statusHistory)
                    this.$refs.statusHistory.initHistory();
            }
        }

    },
    computed: {
        ...mapGetters(['emp', 'farms', "availableFarms"]),
        availableFarmIDs() {
            return (this.availableFarms.length ? this.availableFarms : this.farms).map((farm) => farm.id)
        },
        farmFilteredEmp() {
            return this.emp
                    .filter(emp => this.farmFilter ? emp.fkFarm === this.farmFilter : true)
                    .filter(emp => this.availableFarmIDs.length ? this.availableFarmIDs.includes(emp.fkFarm) || !emp.fkFarm : true)
                    .filter(emp => !this.showDisabled ? !emp.disabled : emp.disabled)
        },
        sortedFarms() {
            return [...this.availableFarms].sort((a,b) => a.description > b.description ? 1 : -1)
        },

        selectedEmp() {
            if (!this.selectedEmpID || this.selectedEmpID.length > 1)
                return null
            return this.emp.filter(obj => obj.id === this.selectedEmpID[0]).pop()
        },
        showDisabled: {
            get() {
                return this.$store.state.showDisabledEmployees
            },
            set(val) {
                this.$store.state.showDisabledEmployees = val
            }
        }
    },
}
</script>

<style scoped>

</style>